// extracted by mini-css-extract-plugin
export default {"Icons__div":"SocialLinks_Icons__div__2hEVD","Icon":"SocialLinks_Icon__W3-eH"};